import React, { useEffect, useState } from 'react';
import { Menu, Dropdown, Button, Popover } from 'antd';
import { useDispatch } from 'react-redux';
import { StateLoader } from '../../../redux/StateLoader';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import { UserOutlined, MessageFilled, DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './Actions.scss';
import { removeUser } from '../../../redux/user/actions';
import { onMessage } from 'firebase/messaging';
import HTTPService from '../../../utils/makerequest';
import { IMessageData } from '../../../interfaces/IMessageData';
import Popconfirm from 'antd/es/popconfirm';
import AltisFirebase from '../../../firebase/firebase';


const Actions: React.FunctionComponent<any> = (props) => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [user, setUser] = useState("");
    const [messages, setMessages] = useState<IMessageData[]>([]);
    const loader = new StateLoader();

    const fetchMessages = () => {
        HTTPService.GET(`/Dashboard/getFirebaseMessage`).then(
          (response) => {
            try {
                if (response.status === 200) {
                    const tmp = response.data.map((item: any) => ({
                        message: item.message, 
                        messageId: item.messageId 
                    }));
                    setMessages(tmp); 
                } else {
                    console.error('Failed to fetch messages');
                }
            } catch (error) {
                console.error('Error fetching messages:', error.toString());
            }
          }
        );
    };
    
    

    useEffect(() => {
        const userInfo: IAuthentication = loader.loadAuthState();
        setUser(`${userInfo?.firstname} ${userInfo?.lastname} - ${UserRole[userInfo?.role]}`);
        fetchMessages()
        firebaseInit();
    }, []);

    const firebaseInit = async () => {
        if(window.location.protocol === "https:"){
            await onMessage((new AltisFirebase).messaging, (payload) => {
                const { notification } = payload;
                const message = { title: notification.title, body: notification.body };
                // addMessageToDB(message);
                //setMessages((prevMessages) => [...prevMessages, message]);
                if (Notification.permission === 'granted') {
                    new Notification(notification.title, { body: notification.body });
                }
            });
        }
    };

    const logout = () => {
        dispatch(removeUser());
        loader.removeAuthLoader();
        window.location.replace('/public/sign-in/');
    };

    const resetPassword = () => {
        window.location.replace('/admin/reset-password');
    };

    const changeEmail = () => {
        window.location.replace('/admin/change-email');
    };

    const changeLanguage = (lng: string) => {
        if (i18n.changeLanguage) {
            i18n.changeLanguage(lng);
            loader.setLanguage(lng);
        } else {
            console.error('i18n.changeLanguage is not a function');
        }
    };

    const languageMenu = (
        <Menu>
            <Menu.Item key='1' onClick={() => changeLanguage('tr')}>
                <img src={require('./turkishflag.png').default} style={{ marginRight: '8px', width: '20px', height: 'auto' }} alt="Turkish Flag" />
                {t('turkish')}
            </Menu.Item>
            <Menu.Item key='2' onClick={() => changeLanguage('en')}>
                <img src={require('./usaflag.png').default} style={{ marginRight: '8px', width: '20px', height: 'auto' }} alt="US Flag" />
                {t('english')}
            </Menu.Item>
        </Menu>
    );
    
    
    

    const accountMenu = (
        <Menu style={{ minWidth: '200px' }}>
            <Menu.SubMenu key='profile' title={t('profile')} style={{ marginLeft: 7 }}>
                <Menu.Item key='reset-password' onClick={resetPassword}>
                    {t('reset_password')}
                </Menu.Item>
                <Menu.Item key='change-email' onClick={changeEmail}>
                    {t('change_email')}
                </Menu.Item>
            </Menu.SubMenu>
            <Menu.Item key='logout'>
                <span className='d-flex justify-content-between align-items-center'>
                    <a className='d-flex w-100' onClick={logout}>
                        {t('log_out')}
                    </a>
                    <span className='d-flex align-items-center icofont-logout' style={{marginLeft:'150px'}} />
                </span>
            </Menu.Item>
        </Menu>
    );

    const buttonText = i18n.language === 'tr' 
    ? <img src={require('./turkishflag.png').default} style={{ width: '20px', height: 'auto' }} /> 
    : <img src={require('./usaflag.png').default} style={{ width: '20px', height: 'auto' }} />;


    const deleteMessage = (messageId: number) => {
        HTTPService.DELETE(`/Dashboard/deleteFirebaseMessage?messageId=${messageId}`).then(
            (response) => {
                if (response.status === 200) {
                    setMessages(prevMessages => prevMessages.filter(msg => msg.messageId !== messageId)); 
                } else {
                    console.error('Failed to delete message');
                }
            }
        ).catch((error) => {
            console.error('Error deleting message:', error.toString());
        });
    };

    
    const messageContent = (
        <div className="message-popover">
            <ul style={{ padding: 0, margin: 0 }}> 
                {messages?.length > 0 ? (
                    messages.map((msg, index) => (
                        <li
                            key={index}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                margin: 0, 
                                padding: 0, 
                            }}
                        >
                            <strong style={{ margin: 0 }}>{msg.message}</strong>
                            <Popconfirm
                                title={t('are_you_sure_message')}
                                okText={t('yes')}
                                okType="danger"
                                cancelText={t('no')}
                                onConfirm={() => deleteMessage(msg.messageId)} 
                            >
                                <button
                                    aria-label="Mesajı sil"
                                    style={{
                                        marginLeft: '10px',
                                        color: 'blue',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transform: 'scale(1)',
                                        padding: 0, 
                                    }}
                                >
                                    <DeleteOutlined />
                                </button>
                            </Popconfirm>
                        </li>
                    ))
                ) : (
                    <li>{t('no_messages')}</li>
                )}
            </ul>
        </div>
    );


    
    const messageIconStyle = {
        fontSize: '20px',
        cursor: 'pointer',
        marginLeft:'5px'
    };

    return (
        <div className='actions'>
            <div>{user}</div>
            <Dropdown overlay={accountMenu} trigger={['click']}>
                <div className='item'>
                    <UserOutlined className='mr-1' />
                    <span className='icofont-simple-down' />
                </div>
            </Dropdown>
            
            <Dropdown overlay={languageMenu} trigger={['click']}>
                <Button className='language-selector'>
                    {buttonText} <span className='icofont-simple-down' />
                </Button>
            </Dropdown>

            <Popover content={messageContent} title={<strong>{t('countOrder')}</strong>} trigger="click">
                <Button className='message-icon' onClick={fetchMessages} style={messageIconStyle}>
                    <MessageFilled style={{ fontSize: '20px'}} />
                </Button>
            </Popover>
        </div>
    );
};

export default Actions;
